import axios from 'axios'
import {getLandingPathOrigin} from "@/api/services/util";
//import {DEFAULT_LANGUAGE_CODE} from "@/configPage";
//import https from 'https'
//const { createProxyMiddleware } = require('http-proxy-middleware');


export const loadPageDataAJ = (full) => {

    const params = { full : full ? 1 : 0 }
    //console.log('getLandingPathOrigin()', getLandingPathOrigin())
    return axios({
        method: 'get',
        url: `${getLandingPathOrigin()}/help_backend/loadPageDataAJ.php`, // https://cp.puzzlebot.top/scripts/getArticles.php https://jsonplaceholder.typicode.com/users
        params,
    })
        .then((r) => {
            //console.log(r);

            if(r.data.ok)
            {
                const status = r.data.ok;
                const rubrics = r.data.rubrics;
                const articles = r.data.articles;
                const client = r.data.client;

                return {"ok" : status, rubrics, articles, client};//r.data;
            }
            else
            {
                throw new Error(r.data.error)
            }
        })
        .catch((r) => {
            if(r) {
                return {"ok": false, "error": r.message};
            }
        });
};

export const loadArticleAJ = (rubric_id, article_id) => {
    //console.log('loadArticleAJ', rubric_id, article_id);

    //const params = { rubric_id, article_id }

    var params = new URLSearchParams();
    params.append('rubric_id', rubric_id);
    params.append('article_id', article_id);

    return axios.post(`${getLandingPathOrigin()}/help_backend/getArticleAJ.php`, params)
        .then((r) => {
            //console.log(r);

            if(r.data.ok)
            {
                const status = r.data.ok;
                return {"ok": status, "article": r.data.article};
            }
            else
            {
                throw new Error(r.data.error)
            }
        })
        .catch((r) => {
            if(r) {
                return {"ok": false, "error": r.message};
            }
        });
};

export const saveRubricAJ = (rubricObj) => {
    //console.log('saveRubricAJ', rubricObj);

    //const params = { 'rubric': rubricObj }

    var params = new URLSearchParams();
    params.append('rubric', JSON.stringify(rubricObj));


    return axios.post(`${getLandingPathOrigin()}/help_backend/saveRubricAJ.php`, params)
        .then((r) => {
            //console.log(r);

            if(r.data.ok)
            {
                const status = r.data.ok;
                const id = r.data.id;
                return {"ok": status, status, id};
            }
            else
            {
                throw new Error(r.data.error)
            }
        })
        .catch((r) => {
            if(r) {
                return {"ok": false, "error": r.message};
            }
        });
}

export const deleteRubricAJ = (rubric_id) => {
    //console.log('deleteRubric', rubric_id);

    const params = { 'id': rubric_id }

    return axios.post(`${getLandingPathOrigin()}/help_backend/deleteRubricAJ.php`, JSON.stringify(params))
        .then((r) => {
            //console.log(r);

            if(r.data.ok)
            {
                const status = r.data.ok;
                return {"ok": status, status};
            }
            else
            {
                throw new Error(r.data.error)
            }
        })
        .catch((r) => {
            if(r) {
                return {"ok": false, "error": r.message};
            }
        });
}

export const saveArticleAJ = (articleObj) => {
    //console.log('saveArticleAJ', articleObj);

    var params = new URLSearchParams();
    params.append('article', JSON.stringify(articleObj));

    return axios.post(`${getLandingPathOrigin()}/help_backend/saveArticleAJ.php`, params)
        .then((r) => {
            //console.log(r);

            if(r.data.ok)
            {
                const status = r.data.ok;
                const id = r.data.id;
                const date = r.data.date;
                return {"ok": status, status, id, date};
            }
            else
            {
                throw new Error(r.data.error)
            }
        })
        .catch((r) => {
            if(r) {
                return {"ok": false, "error": r.message};
            }
        });
}

export const changeLanguageAJ = (lang) => {
    //console.log('changeLanguageAJ', lang);

    var params = new URLSearchParams();
    params.append('lang', lang);

    return axios.post(`${getLandingPathOrigin()}/help_backend/changeLanguageAJ.php`, params)
        .then((r) => {
            //console.log(r);

            if(r.data.ok)
            {
                const status = r.data.ok;
                const lang = r.data.lang;

                return {"ok": status, lang};
            }
            else
            {
                throw new Error(r.data.error)
            }
        })
        .catch((r) => {
            if(r) {
                return {"ok": false, "error": r.message};
            }
        });
}

export const deleteArticleAJ = (rubric_id, article_id) => {
    //console.log('deleteArticleAJ', rubric_id,article_id);

    const params = { rubric_id, article_id }

    return axios.post(`${getLandingPathOrigin()}/help_backend/deleteArticleAJ.php`, JSON.stringify(params))
        .then((r) => {
            //console.log(r);

            if(r.data.ok)
            {
                const status = r.data.ok;
                return {"ok": status, status};
            }
            else
            {
                throw new Error(r.data.error)
            }
        })
        .catch((r) => {
            if(r) {
                return {"ok": false, "error": r.message};
            }
        });
}

export const uploadImage = (article_id, lang, file) => {
    //const params = { article_id, lang, 'file_0': file }

    //console.log('params', params)

    var formData = new FormData();
    formData.append('lang', lang);
    formData.append('article_id', article_id);
    formData.append('file_0', file);

    return axios.post(
        `${getLandingPathOrigin()}/help_backend/uploadFileAJ.php`,
        formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
        .then((r) => {
            //console.log(r);

            if(r.data.ok)
            {
                const status = r.data.ok;
                const hashs_files = r.data.hashs_files;
                return {"ok": status, hashs_files};
            }
            else
            {
                throw new Error(r.data.error)
            }
        })
        .catch((r) => {
            if(r) {
                return {"ok": false, "error": r.message};
            }
        });
}
